import React from 'react';
import PropTypes from 'prop-types';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import Card from 'common/card/Card';
import CardContentPanel from 'common/card/CardContentPanel';
import HowToRedeem from 'spot-details/redeem/HowToRedeem';

const IMAGE_WIDTH = 70;
const IMAGE_HEIGHT = 48;
const ARRIVAL_TITLE = 'Arrival Instructions';
const RETURN_TITLE = 'Return Instructions';

const HowToParkCardPanel = ({
    facility,
    selectedRate,
    isMonthly,
    collapsible,
    collapsibleDirections,
    isOpen
}) => {
    const baseProps = {
        facility,
        rate: selectedRate,
        isMonthly,
        imgWidth: IMAGE_WIDTH,
        imgHeight: IMAGE_HEIGHT,
        isAirport: true
    };
    const arrivalProps = {
        ...baseProps,
        airportSection: 'arrival',
        sectionTitle: (!collapsibleDirections) ? ARRIVAL_TITLE : null
    };
    const returnProps = {
        ...baseProps,
        airportSection: 'departure',
        sectionTitle: (!collapsibleDirections) ? RETURN_TITLE : null
    };

    return (
        <Card
            id="how-to-park"
            className="HowToParkCardPanel"
            title="How To Park"
            collapsible={collapsible}
            isOpen={isOpen}
        >
            {(collapsibleDirections) ?
                (
                    <CardContentPanel
                        title={ARRIVAL_TITLE}
                        showContentOnPrint
                    >
                        <HowToRedeem {...arrivalProps} />
                    </CardContentPanel>
                ) : (
                    <HowToRedeem {...arrivalProps} />
                )
            }
            {collapsibleDirections &&
                <HorizontalRule />
            }
            {(collapsibleDirections) ?
                (
                    <CardContentPanel
                        title={RETURN_TITLE}
                        showContentOnPrint
                    >
                        <HowToRedeem {...returnProps} />
                    </CardContentPanel>
                ) : (
                    <HowToRedeem {...returnProps} />
                )
            }
        </Card>
    );
};

HowToParkCardPanel.propTypes = {
    facility: PropTypes.object.isRequired,
    selectedRate: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]).isRequired,
    isMonthly: PropTypes.bool.isRequired,
    collapsible: PropTypes.bool,
    collapsibleDirections: PropTypes.bool,
    isOpen: PropTypes.bool
};

export default HowToParkCardPanel;
